import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import dayjs from 'dayjs';

import Home from './pages/Home';
import Imprensa from './pages/Imprensa';
import Inscricao from './pages/Inscricao';
import InscricaoVip from './pages/InscricaoVip';
import InscricaoImprensa from './pages/InscricaoImprensa';
import InscricaoImprensaVip from './pages/InscricaoImprensaVip';
import About from './pages/About';
import Login from './pages/Login';
import Salas from './pages/Salas';
import Agenda from './pages/Agenda';
import Events from './pages/Events';
import Local from './pages/Local';
import News from './pages/News';
import Panel from './pages/Panel';

export default function Routing() {
    
    /*function GetRedirect(){
        const today = dayjs();
        const formattedDate = today.format('YYYY-MM-DD HH:mm');
        const targetDate = dayjs('2024-02-22 10:00');
        const hasPassed = targetDate.isBefore(formattedDate);
        if(hasPassed) return <Inscricao1 />; else return <Inscricao2 />;
    }*/

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/sobre" element={<About />} />
                {/* <Route path="/inscricao" element={<Inscricao />} />
                <Route path="/inscricao-imprensa" element={<InscricaoImprensa />} /> */}
                <Route path="/inscricao" element={<Navigate replace to="/" />} />
                <Route path="/inscricao-imprensa" element={<Navigate replace to="/" />} />
                {/* <Route path="/inscricao-vip" element={<InscricaoVip />} />
                <Route path="/inscricao-imprensa-vip" element={<InscricaoImprensaVip />} />
                <Route path="/inscricao-update" element={<InscricaoUpdate />} /> */}
                <Route path="/imprensa" element={<Imprensa />} />
                <Route path="/login" element={<Login />} />
                <Route path="/assistir" element={<Salas />} />
                <Route path="/sala/:url?" element={<Salas />} />
                <Route path="/materias" element={<News />} />
                <Route path="/materia/:url?" element={<News />} />
                <Route path="/painelistas" element={<Panel />} />
                <Route path="/painelista/:url?" element={<Panel />} />
                <Route path="/eventos-paralelos" element={<Events />} />
                <Route path="/evento/:url?" element={<Events />} />
                <Route path="/agenda" element={<Agenda />} />
                <Route path="/local-evento" element={<Local />} />
            </Routes>
        </BrowserRouter>
    );
}